<template>
  <master-crud-page
    master="bunker_location"
    title="Bunker Location"
    access="master_bunker_location"
    pk="mbloId"
    :columns="columns"
    :fields="fields"
  />
</template>

<script>
import MasterCrudPage from '@/components/master/MasterCrudPage';
import { formatDateTime } from '@/util/date';
import { DISPLAY_DATE } from '@/util/apiDatetime';

export default {
  name: 'MasterBunkerLocation',
  components: { MasterCrudPage },
  data() {
    return {
      columns: [
        { key: 'mbloName', label: 'Bunker Location Name', align: 'left' },
        { key: 'mbloCreatedUserId', label: 'Created By', align: 'center' },
        {
          key: 'mbloCreatedTime',
          label: 'Created',
          align: 'center',
          formatter: (value) => formatDateTime(value, DISPLAY_DATE),
        },
      ],
      fields: [
        {
          key: 'mbloName',
          label: 'Bunker Location Name',
          type: 'text',
          required: true,
        },
      ],
    };
  },
};
</script>
